import { render, staticRenderFns } from "./d-book-user-review-author.vue?vue&type=template&id=0e492081&scoped=true&"
import script from "./d-book-user-review-author.vue?vue&type=script&lang=js&"
export * from "./d-book-user-review-author.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-review-author.vue?vue&type=style&index=0&id=0e492081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e492081",
  null
  
)

export default component.exports